"use client";

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import ROUTE_URLS from "@/constants/route-urls";
import useLanguage from "@/contexts/language-context";

/**
 * Hook para redirecionar o usuário caso ele não tenha permissão.
 *
 * @param hasNoPermission Indica se o usuário não possui permissão.
 * @param redirectUrl (Opcional) Rota para redirecionar caso não tenha permissão. Por padrão, redireciona para a rota do serviceDashboard.
 * @param delay (Opcional) Tempo de delay para efetuar o redirecionamento, padrão 3000ms.
 */

export function useProtectPage(
  hasNoPermission: boolean,
  redirectUrl?: string,
  delay: number = 3000
) {
  const { lang } = useLanguage();
  const router = useNavigate();

  useEffect(() => {
    if (!hasNoPermission) return;
    const finalRedirectUrl = redirectUrl || ROUTE_URLS.serviceDashboard(lang);

    const timer = setTimeout(() => {
      router(finalRedirectUrl);
    }, delay);

    return () => clearTimeout(timer);
  }, [hasNoPermission, redirectUrl, lang, router, delay]);
}
